export enum StringFilterOperatorEnum {
  CONTAINS = "CONTAINS",
  EQUALS = "EQUALS",
  STARTS_WITH = "STARTS_WITH",
  ENDS_WITH = "ENDS_WITH",
}

export enum NumberFilterOperatorEnum {
  CONTAINS = "CONTAINS",
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUALS",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUALS",
}

export enum ListFilterOperatorEnum {
  CONTAINS = "IN",
  NOT_CONTAINS = "NOT_IN",
}

export enum FilterValidationErrorEnum {
  MISSING_FIELD = "MISSING_FIELD",
  MISSING_OPERATOR = "MISSING_OPERATOR",
  MISSING_VALUE = "MISSING_VALUE",
}
